<div class="password-reset">
  <div class="password-reset__logo">
    <app-logo
      [routerLink]="['/']"
    ></app-logo>
  </div>

  @if (!hasTokenInUrl) {
    <h2>{{ 'password-reset.title' | transloco }}</h2>
    <p>{{'password-reset.explanation' | transloco}}</p>

    <form [formGroup]="requestForm">
      <div class="input-group">
        <label for="email">{{ 'password-reset.email.label' | transloco }}</label>
        <input type="email" placeholder="{{ 'password-reset.email.placeholder' | transloco }}" formControlName="email" />
      </div>
    </form>

    <div class="password-reset__actions">
      <button class="button button--white"
              [routerLink]="['/login']"
      >
        {{'password-reset.cancel' | transloco}}
      </button>
      <button class="button button--primary"
              [class.button--loading]="loading"
              (click)="resetPassword()"
              [disabled]="requestForm.invalid || loading"
      >
        {{'password-reset.cta-label' | transloco}}
      </button>
    </div>
  } @else {
    <form [formGroup]="resetPasswordForm">
      <div class="input-group">
        <label for="password">{{ 'password-reset.password.label' | transloco }}</label>
        <input type="password" placeholder="{{ 'password-reset.password.placeholder' | transloco }}" formControlName="password" />
      </div>
      <div class="input-group">
        <label for="password-confirm">{{ 'password-reset.password-confirm.label' | transloco }}</label>
        <input type="password" placeholder="{{ 'password-reset.password-confirm.placeholder' | transloco }}" formControlName="passwordConfirm" />
      </div>
    </form>

    <div class="password-reset__actions">
      <button class="button button--white"
              [routerLink]="['/login']"
      >
        {{'password-reset.cancel' | transloco}}
      </button>
      <button class="button button--primary"
              [class.button--loading]="loading"
              (click)="resetPasswordWithToken()"
              [disabled]="resetPasswordForm.invalid || loading
              || resetPasswordForm.get('password')?.value !== resetPasswordForm.get('passwordConfirm')?.value"
      >
        {{'password-reset.cta-label' | transloco}}
      </button>
    </div>
  }

</div>
